export default {
  methods: {
    startFixedBlock(wrapperEl, blockEl) {
      if (!wrapperEl || !blockEl) return

      const wrapper = document.querySelector(wrapperEl)
      const image = document.querySelector(blockEl)

      if (wrapper && image) {
        document.addEventListener('scroll', (e) => {
          if (wrapper.clientHeight > image.clientHeight) {
            const imageHeight = image.offsetTop + image.clientHeight
            const wrapperHeight = wrapper.offsetTop + wrapper.clientHeight
            const screenHeight = window.innerHeight + window.scrollY

            if (
              screenHeight >= wrapperHeight + 150 &&
              wrapperHeight + 1 > imageHeight
            ) {
              image.style.position = 'absolute'
              image.style.bottom = '0'
              image.style.top = 'auto'
            } else if (wrapperHeight > imageHeight) {
              if (window.scrollY > 82) {
                image.style.position = 'sticky'
                image.style.bottom = 'auto'
                image.style.top =
                  window.innerHeight / 2 - image.clientHeight / 2 + 'px'
              } else {
                image.style.position = 'relative'
                image.style.top = 'auto'
                image.style.bottom = 'auto'
              }
            } else {
              image.style.position = 'sticky'
              image.style.bottom = 'auto'
              image.style.top =
                window.innerHeight / 2 - image.clientHeight / 2 + 'px'
            }
          }
        })
      }
    },
  },
}
